var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bdd-application-list-tools"},[_c('r-filter-set',{attrs:{"filters":_vm.filters},on:{"reset-all":_vm.resetFilters,"load":_vm.updateFilters}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }